import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import ProtectedRoute from "components/ProtectedRoute";
import AppLayout from "components/AppLayout";

import {
  WelcomePage,
  ProductsPage,
  ExclusionsPage,
  RecommendationPage,
  PartnersPage,
  SupplyReportPage,
  BotSettingsPage,
  LoginPage,
  ExtensionAuthPage,
  ShopSettingsPage,
  AdminPanelPage,
  DeveloperPage,
  TrapSkuPage,
  AnalysisPromPage,
  StatsManagerPage,
  ManagerBotPage,
  ABCPage,
  GeneralPage,
  CompetitorsParsingPage,
} from "features";

function RootRouter() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        {/* Вхід для розширення KeyCRM: без навігації, як і /login */}
        <Route path="/extension-auth" element={<ExtensionAuthPage />} />

        <Route element={<AppLayout />}>
          <Route path="/" element={<WelcomePage />} />

          <Route element={<ProtectedRoute requiredPermission="recommendations:view" />}>
            <Route path="/recommendation" element={<RecommendationPage />} />
          </Route>

          <Route element={<ProtectedRoute requiredPermission="products:view" />}>
            <Route path="/products" element={<ProductsPage />} />
          </Route>

          <Route element={<ProtectedRoute requiredPermission="exclusions:view" />}>
            <Route path="/exclusions" element={<ExclusionsPage />} />
          </Route>

          <Route element={<ProtectedRoute requiredPermission="traps:view" />}>
            <Route path="/trap" element={<TrapSkuPage />} />
          </Route>

          <Route element={<ProtectedRoute requiredPermission="partners:view" />}>
            <Route path="/partners" element={<PartnersPage />} />
          </Route>

          <Route element={<ProtectedRoute requiredPermission="supply_report:view" />}>
            <Route path="/supply-report" element={<SupplyReportPage />} />
          </Route>

          <Route element={<ProtectedRoute requiredPermission="bot:view" />}>
            <Route path="/bot-settings" element={<BotSettingsPage />} />
          </Route>

          <Route element={<ProtectedRoute requiredPermission="users:view" />}>
            <Route path="/admin-profile" element={<AdminPanelPage />} />
          </Route>

          <Route element={<ProtectedRoute requiredPermission="api-tokens:manage" />}>
            <Route path="/developer" element={<DeveloperPage />} />
          </Route>

          <Route element={<ProtectedRoute requiredPermission="shop-settings:view" />}>
            <Route path="/shops-by-suppliers" element={<ShopSettingsPage />} />
          </Route>

          {/* Dashboard routes */}

          <Route element={<ProtectedRoute requiredPermission="dashboard-prom:view" />}>
            <Route path="/analyz-prom" element={<AnalysisPromPage />} />
          </Route>

          <Route
            element={
              <ProtectedRoute requiredPermission="dashboard-sellers-stats:view" />
            }
          >
            <Route path="/stats-manager" element={<StatsManagerPage />} />
          </Route>

          <Route
            element={<ProtectedRoute requiredPermission="dashboard-sellers-bot:view" />}
          >
            <Route path="/manager-bot" element={<ManagerBotPage />} />
          </Route>

          <Route element={<ProtectedRoute requiredPermission="dashboard-abc:view" />}>
            <Route path="/abc" element={<ABCPage />} />
          </Route>

          <Route element={<ProtectedRoute requiredPermission="dashboard-general:view" />}>
            <Route path="/general" element={<GeneralPage />} />
          </Route>

          <Route
            element={
              <ProtectedRoute requiredPermission="dashboard-competitors-parsing:view" />
            }
          >
            <Route path="/competitors-parsing" element={<CompetitorsParsingPage />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default RootRouter;
